const Loading = () => {
  return (
    <div className="w-full h-screen flex justify-center items-center flex-col"></div>
  )
}

export default Loading
